module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_6005.1356d5e2.png";